<template lang="pug">
  component(
    :is="component"
    v-bind="{ value, type, label, error, options, disabled, name, autocomplete, unit, labelOuter }"
    v-on="listeners"
    ref="input"
    )
</template>

<script>
import BaseDatepicker from '@/components/BaseDatepicker.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import BaseInput from '@/components/BaseInput.vue';
import BasePhoneInput from '@/components/BasePhoneInput.vue';
import BaseTextarea from '@/components/BaseTextarea.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';

export default {
  name: 'BaseField',
  components: {
    BaseInput,
    BaseDatepicker,
    BaseSelect,
    BaseSelectMulti,
    BaseTextarea,
    BasePhoneInput,
    BaseCheckbox,
  },
  props: {
    value: [String, Date, Number, Boolean, Array],
    type: String,
    label: String,
    error: String,
    options: [Object, Array],
    disabled: Boolean,
    name: String,
    autocomplete: String,
    unit: String,
    labelOuter: Boolean,
  },
  computed: {
    component() {
      switch (this.type) {
        case 'date':
        case 'datetime':
          return BaseDatepicker;
        case 'select':
          return BaseSelect;
        case 'multi':
          return BaseSelectMulti;
        case 'textarea':
          return BaseTextarea;
        case 'tel':
          return BasePhoneInput;
        case 'checkbox':
          return BaseCheckbox;
        default:
          return BaseInput;
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => this.$emit('input', value),
      };
    },
  },
  methods: {
    focus() {
      this.$refs.input?.focus?.(); // eslint-disable-line
    },
  },
};
</script>

<style scoped>

</style>
